import { ApiLessonAsset } from './ApiLessonAsset';

export enum ModuleType {
  Unknown = 0,
  xAPI = 1,
  Lesson = 2, //* auto-mark, feedback.
  Quiz = 3, //* auto-mark, lock.
  Assessment = 4, //* auto-mark, submit.
  Critique = 5, //* submit.
  Rubric = 6 //* auto-mark, hidden.
}

export enum ModuleBehaviourEnum {
  None = 0x0000,
  ShowAllVersions = 0x0001,
  EditAllVersions = 0x0002,
  LockCourse = 0x0004,
  SingleAttemptPerVersion = 0x0008 // moved to LessonVersionAsset -> LessonNativeSettings
  //* LockCompletedVersions = ??? // will be added later?
}

export interface ApiLesson {
  coursekey: number;
  modulekey: number;
  title: string;
  created: Date;
  archived: Date;
  assets: ApiLessonAsset;
}
